<script>
  import { afterUpdate, onMount } from "svelte"
  import bulkUploadOperations from "../../../Stores/uploadFlow"
  import InnerContent from "./innerContent.svelte"
  export let parent = []
  export let active
  export let index

  /**
   * @type {Boolean} whether to show the content or not
   */
  let hideContent
  /**
   * @type {Number} indicates the active child row
   */
  let innerActive = 0

  onMount(() => {
    hideContent = index == active
  })

  afterUpdate(() => {
    hideContent = index == active
  })
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  on:click={() => {
    if (!hideContent) active = index
    else active = undefined
    hideContent = !hideContent
  }}
  class="flex {index == active ? 'bg-red-500 text-white' : 'bg-[#f7f7f7] text-gray-800 dark:bg-bodyblack dark:text-gray-200'} w-full cursor-pointer items-center justify-between rounded-md px-3 py-2"
>
  <!-- <div
  on:click={() => {
    if (!hideContent) active = index
    else active = undefined
    hideContent = !hideContent
  }}
  class="flex {index == active ? 'bg-[#f8d7da] text-[#ff0c0c]' : 'bg-[#f7f7f7] text-gray-800'} w-full cursor-pointer items-center justify-between rounded-md px-3 py-2"
> -->
  <h1 class="text-base font-bold">{parent}</h1>
  <span>
    <i class="fa-solid {index == active ? 'fa-chevron-up' : 'fa-chevron-down'} " />
  </span>
</div>
{#if hideContent}
  <div class="flex w-full flex-wrap gap-3 px-3">
    {#each Object.entries($bulkUploadOperations.invalidObj[parent]) as [key, value], i}
      <InnerContent {key} {value} index={i} bind:innerActive />
    {/each}
  </div>
{/if}
